var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlpp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.6339,
    y: 65,
    width: 76.0697,
    height: 380.349,
    fill: "#BED0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.954 440.911C126.365 440.911 130.802 444.715 130.802 444.715H56L57.2678 65.6339H71.2139V419.358C71.2139 419.358 72.4818 427.599 83.8922 433.304C95.3027 439.009 106.725 440.911 114.954 440.911Z",
    fill: "#9B9B9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.367,
    y: 128.391,
    width: 50.7132,
    height: 253.566,
    fill: "#BED0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.247 378.999C187.854 378.999 190.813 381.535 190.813 381.535H140.945L141.79 128.814H151.087V364.63C151.087 364.63 151.932 370.124 159.539 373.928C167.146 377.731 174.761 378.999 180.247 378.999Z",
    fill: "#9B9B9B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320.131,
    y: 128.391,
    width: 50.7132,
    height: 253.566,
    fill: "#BED0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.011 378.999C366.618 378.999 369.576 381.535 369.576 381.535H319.708L320.554 128.814H329.851V364.63C329.851 364.63 330.696 370.124 338.303 373.928C345.91 377.731 353.525 378.999 359.011 378.999Z",
    fill: "#9B9B9B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 260.543,
    y: 128.391,
    width: 50.7132,
    height: 253.566,
    fill: "#BED0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.423 378.999C307.03 378.999 309.988 381.535 309.988 381.535H260.12L260.966 128.814H270.263V364.63C270.263 364.63 271.108 370.124 278.715 373.928C286.322 377.731 293.937 378.999 299.423 378.999Z",
    fill: "#9B9B9B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 200.955,
    y: 128.391,
    width: 50.7132,
    height: 253.566,
    fill: "#BED0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.835 378.999C247.442 378.999 250.4 381.535 250.4 381.535H200.532L201.378 128.814H210.675V364.63C210.675 364.63 211.52 370.124 219.127 373.928C226.734 377.731 234.349 378.999 239.835 378.999Z",
    fill: "#9B9B9B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 379.93,
    y: 66.2678,
    width: 76.0697,
    height: 380.349,
    fill: "#BED0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M438.25 442.179C449.661 442.179 454.098 445.983 454.098 445.983H379.296L380.564 66.9017H394.51V420.626C394.51 420.626 395.778 428.867 407.189 434.572C418.599 440.277 430.021 442.179 438.25 442.179Z",
    fill: "#9B9B9B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlpp);
export default __webpack_public_path__ + "static/media/plpp.ac37bb10cf84db8f5a11b17c432f0b40.svg";
export { ForwardRef as ReactComponent };